export function resolveBackendBaseUrl(): string {
  if (import.meta.env.DEV) {
    const fromEnv = import.meta.env.VITE_BACKEND_API_URL?.trim();
    if (fromEnv) {
      return fromEnv.replace(/\/+$/, '');
    }
  }

  return window.location.origin;
}
